// extracted by mini-css-extract-plugin
export default {"offlineBanner":"styles__offlineBanner___SG1Mz","currentlyOffline":"styles__currentlyOffline___s35jV"};